import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";

export const StickyBack = ({ onClick, children }) => {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => setP(Math.min(window.scrollY / 120, 1));
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const stuck = p > 0.5;
  return (
    <button
      data-testid="sticky-back"
      data-stuck={stuck}
      onClick={onClick}
      style={{ boxShadow: `0 0 0 100vmax rgba(255,252,246,${p})` }}
      className={`sticky top-[84px] z-10 flex w-fit items-center gap-2 rounded-full border px-4 py-2 text-sm [clip-path:inset(-12px_-100vmax_-12px_-100vmax)] transition-[background-color,color,border-color] duration-700 ease-out ${
        stuck ? "border-bordeaux bg-bordeaux text-white" : "border-line bg-white text-ink-soft hover:text-bordeaux"
      }`}
    >
      <ArrowLeft size={16} /> {children}
    </button>
  );
};
